import styles from './PreviewStackDialog.module.css'

export type PreviewStackDescriptionProps = {
  isExtendingExistingStack: boolean
  existingStackNumber?: number | null
  hasOtherNewlyAddedPulls: boolean
}

export function PreviewStackDescription({
  isExtendingExistingStack,
  existingStackNumber,
  hasOtherNewlyAddedPulls,
}: PreviewStackDescriptionProps) {
  if (isExtendingExistingStack && existingStackNumber != null) {
    return (
      <p className={styles.description}>
        {`This pull request${hasOtherNewlyAddedPulls ? ' and other pull requests' : ''} can be added to stack #${existingStackNumber}. Review and update the stack when you’re ready.`}
      </p>
    )
  }

  return (
    <p className={styles.description}>
      This pull request can be stacked with other pull requests. Review and create the stack when you’re ready.
    </p>
  )
}
